// extracted by mini-css-extract-plugin
export default {"header_span":"Home_header_span__tvwDm","header_desc":"Home_header_desc__FYG+8","btn_header":"Home_btn_header__W+YZ5","item_header":"Home_item_header__8I16r"};